// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__dNBJ1","icon":"Tooltip_icon__qJFW_","text":"Tooltip_text__5ExAe"};